document.addEventListener('DOMContentLoaded', () => {
    // CSSのメディアクエリと一致する条件
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const ANIMATION_DURATION = 300; // CSSとJSで統一

    // 子メニュー（.child）を持つリストアイテム（.footer-navitem）を取得
    const itemsWithChild = document.querySelectorAll('.footer-navitem:has(.child)');

    // クラス追加はそのまま
    itemsWithChild.forEach(item => {
        item.classList.add('has-submenu');
    });
    
    // ===========================================
    // ★★★ 修正されたアニメーション処理関数 (スライドトグル) ★★★
    // ===========================================
    // const ANIMATION_DURATION = 300; // CSS と合わせる

    const slideToggle = (element, item, duration) => {
        const isOpen = item.classList.contains('is-open');
        const scrollHeight = element.scrollHeight;

        // remove any existing transitionend handler to avoid duplicates
        const clearTransitionHandler = () => {
            // noop - kept for symmetry if needed later
        };

        if (isOpen) {
            // ---- 閉じる ----
            // 1) 現在の高さを明示的にセット（ピクセル値）
            element.style.maxHeight = scrollHeight + 'px';

            // 2) force repaint then アニメーションで 0 にする
            requestAnimationFrame(() => {
                element.style.maxHeight = '0';
            });

            // 3) transitionend でクリーンアップ（確実）
            const onCloseEnd = (e) => {
                if (e.propertyName !== 'max-height') return;
                item.classList.remove('is-open');
                element.style.maxHeight = ''; // インライン削除（CSS に戻す）
                element.removeEventListener('transitionend', onCloseEnd);
            };
            element.addEventListener('transitionend', onCloseEnd);

            // フォールバック：transitionend が来ない場合の安全処理
            setTimeout(() => {
                if (item.classList.contains('is-open')) return; // まだ開いてたら何もしない
                // 既に閉じ終わってたら何もしない
                element.style.maxHeight = '';
                element.removeEventListener('transitionend', onCloseEnd);
            }, duration + 50);

        } else {
            // ---- 開く ----
            // 1) is-open を先に付ける（CSS 側の表示調整に備える）
            item.classList.add('is-open');

            // 2) 直後に高さをピクセル指定してアニメーション開始
            //    （display:block 等が必要なら .is-open の CSS で行っている前提）
            element.style.maxHeight = '0'; // 明示的にリセットしてから
            // force repaint
            requestAnimationFrame(() => {
                element.style.maxHeight = scrollHeight + 'px';
            });

            // 3) transitionend で inline 設定を残すかクリアするか決める
            //    → ここでは「開いたあとは inline を残す」方針（競合を防ぐ）
            const onOpenEnd = (e) => {
                if (e.propertyName !== 'max-height') return;
                // 開いた状態は inline の px を残す（安定するため）
                // element.style.maxHeight = ''; // ← ここはしない（すぐ消すと CSS によって閉じる恐れ）
                element.removeEventListener('transitionend', onOpenEnd);
            };
            element.addEventListener('transitionend', onOpenEnd);

            // フォールバック：transitionend が来ない場合は duration経過で解除
            setTimeout(() => {
                element.removeEventListener('transitionend', onOpenEnd);
            }, duration + 50);
        }
    };
    // ===========================================
    // ★★★ イベントリスナーの修正 ★★★
    // ===========================================
    itemsWithChild.forEach(item => {
        const anchor = item.querySelector('a');
        const childMenu = item.querySelector('.child'); 

        if (anchor && childMenu) {
            anchor.addEventListener('click', (event) => {

                if (mediaQuery.matches) {
                    event.preventDefault();
                    event.stopPropagation();

                    // 1. 他のメニューを閉じる
                    itemsWithChild.forEach(otherItem => {
                        const otherChild = otherItem.querySelector('.child');
                        if (otherItem !== item && otherItem.classList.contains('is-open')) {
                            slideToggle(otherChild, otherItem, ANIMATION_DURATION);
                        }
                    });

                    // 2. 自分をトグル
                    slideToggle(childMenu, item, ANIMATION_DURATION);
                    return;
                }

            }, false);
        }
    });

    // ===========================================
    // ★★★ 画面サイズ変更時の処理の修正 ★★★
    // ===========================================
    function handleMediaQueryChange(e) {
        itemsWithChild.forEach(item => {
            const anchor = item.querySelector('a');
            const childMenu = item.querySelector('.child');

            if (e.matches) {
                // 767px以下 (モバイル時): リンクを一時的に無効化
                if (!anchor.hasAttribute('data-original-href')) {
                    anchor.setAttribute('data-original-href', anchor.getAttribute('href'));
                    anchor.setAttribute('href', '#');
                }
                // アコーディオンアニメーションのために高さをリセット
                // childMenu.style.maxHeight = '0';
                item.classList.remove('is-open'); 
                
            } else {
                // 768px以上 (PC時): リンクを元に戻し、スタイルをクリア
                if (anchor.hasAttribute('data-original-href')) {
                    anchor.setAttribute('href', anchor.getAttribute('data-original-href'));
                    anchor.removeAttribute('data-original-href');
                }
                // PC表示では max-height をクリアし、常に表示させる
                childMenu.style.maxHeight = ''; 
                item.classList.remove('is-open'); 
            }
        });
    }

    mediaQuery.addListener(handleMediaQueryChange);
    handleMediaQueryChange(mediaQuery);
});

// テーブルに横スクロールヒント付与
new ScrollHint('.scroll', {
  suggestiveShadow: true, //スクロール可能な要素右端に影を付ける
  i18n: {
    scrollable: '横スクロール可能です' //表示するテキスト
  }
});

// 選べる和牛ギフトの内容紹介
// タブを切り替える基本関数
function openTab(evt, contentId) {
  const contents = document.querySelectorAll('.tab-content');
  contents.forEach(content => content.style.display = 'none');

  const buttons = document.querySelectorAll('.tab-btn');
  buttons.forEach(btn => btn.classList.remove('active'));

  document.getElementById(contentId).style.display = 'block';
  if (evt) {
    evt.currentTarget.classList.add('active');
  } else {
    // IDからボタンを特定してactiveをつける（初期読み込み用）
    const btnId = contentId.replace('content-', '');
    document.getElementById(btnId).classList.add('active');
  }

  // 【追加】クリックされたタブのIDを特定する（content-matsusaka から matsusaka を取り出す）
  const key = contentId.replace('content-', '');

  // 【追加】上のテキストエリア(id="tab-title-text")の中身を書き換える
  // tabTexts['matsusaka'] のような形でデータを取り出しています
  document.getElementById('tab-title-text').innerText = tabTexts[key];

}

// ページ読み込み時の処理
window.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash; // 例: "#hitachi"
  
  if (hash) {
    const targetId = hash.replace('#', '');
    const targetBtn = document.getElementById(targetId);
    
    if (targetBtn) {
      // ハッシュに合うボタンがあれば、そのタブを開く
      openTab(null, 'content-' + targetId);
      return; // 処理終了
    }
  }
  
  // ハッシュがない、または該当しない場合はデフォルト（松阪牛）を表示
  openTab(null, 'content-matsusaka');
});